import { BASE_PATHS } from '@oneclick/constants/navigation';

/** Cluster chooser belongs only on cluster-scoped routes. */
export const shouldShowClusterSelect = (pathname: string): boolean =>
  pathname.startsWith(BASE_PATHS.externalClusters);
